<template>
  <div class="ViewChambers">
    <Chambers :chambers="chambers" class="chambers"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Chambers from '@/components/Chambers.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'ViewChambers',
  components: {
    Chambers
  },
  data: function () {
    return {
      chambers: []
    }
  },
  computed: {
    ...mapGetters('chambers',[
      'chambersByRoutes',
    ]),
    routes: function () {
      return this.$route.params.routes.split(',');
    }
  },
  watch: {
    routes: function () {
      this.setRoutesFromParam();
    }
  },
  methods:{
    setRoutesFromParam: function () {
      this.chambers = this.chambersByRoutes(this.routes)
    }
  },
  mounted: function () {
    this.setRoutesFromParam();
  }
}
</script>

<style scoped lang="scss">

  .ViewChambers{
  }

}
